import { AxiosInstance } from 'axios';
import { executeGqlQuery } from './gql';
import objectsQuery from '../gql/objectsQuery.gql';
import objectIdsQuery from '../gql/objectIdsQuery.gql';
import objectsTeaserQuery from '../gql/objectsTeaserQuery.gql';
import Pagination from '../@types/pagination';
import Sort from '../@types/sort';

const getObjects = async (
  api: AxiosInstance,
  lang: 'de' | 'en',
  filter: any,
  pagination: Pagination,
  sort?: Sort,
  onlyTeaser = false
): Promise<any> => {
  const query = onlyTeaser ? objectsTeaserQuery : objectsQuery;

  return executeGqlQuery(
    api,
    query,
    {
      filter,
      pagination,
      sort,
      lang: lang.toUpperCase(),
    },
    ({
      objects: result,
    }: {
      objects: { objects: any; totalCount: number; filter: any };
    }) => {
      return result;
    }
  );
};

export const getObjectIds = async (
  api: AxiosInstance,
  lang: 'de' | 'en',
  filter: any,
  pagination: Pagination,
  sort?: Sort
): Promise<any> => {
  return executeGqlQuery(
    api,
    objectIdsQuery,
    {
      filter,
      pagination,
      sort,
      lang: lang.toUpperCase(),
    },
    ({ objects: result }: { objects: { objects: any } }) => {
      return result;
    }
  );
};

export default getObjects;
